// CONSTANTS are all caps.
const NS = 'RecommendationsBlock';
const CLS = 'recommendationsBlock';
const BLK = '.' + CLS + '-';
const CLS_LOADING = 'is-loading';
const CLS_HIDE = 'd-none';
const CLS_ACTIVE = 'is-active';
const CLS_ACTIVE_VARIANT = 'is-active-variant';
const CLS_HAS_INITED = 'has-inited';
const CLS_HAS_VARIANT = 'has-variant';

const D_VAR_CODE = 'variant-code';
const D_ITEM_DESC = 'item-description';
const D_ITEM_CODE = 'item-code';
const D_PROD_TYPE = 'product-type';
const D_REC_ID = 'recommendation-id';
const D_SALE_AVAIL = 'sale-availability';
const D_SKU = 'sku';
const BLK_PROD_LIST = 'productListingBlock';
const SALE_AVAILABILITY_INSTORE_NO_PRICE_VALUE = "ISONP";
const SALE_AVAILABILITY_INSTORE_VALUE = "ISOOP";
const PRODUCT_TYPE = {
	GENERIC: 'generic',
	COLOR: 'color',
	SIZE: 'size',
	COLOR_SIZE: 'colorsize'
};

const PRODUCT_CLASS = {
	COLOR: 'colors',
	SIZE: 'sizes',
	GENERIC: 'generic'
}

import * as utils from '../../../../global/js/utils';
import * as Api from '../../../../global/js/api';
import * as klevuService from '../../../../global/js/klevuService';
import Handlebars from 'handlebars';
import '../../../../global/helpers/obj';
import {addToCart} from '../../../../global/js/cart';
import {EVENT_PRODUCT_QUICKVEW_SHOW} from '../../../../global/js/constants';

export class RecommendationsBlock {
	constructor(el) {
		this.el = el;
		this.$el = $(el);

		this.getProductsUrl = this.$el.data('getProductsUrl') || '';
		this.products = this.$el.data('products') || '';
		this.recommendationsType = this.$el.data('recommendationsType');
		this.refCode = this.$el.data('productcode') || '';
      	this.productName = this.$el.data('productname') || '';
      	this.recs = this.$el.data('recs') || '';
		this.contentTmpl;
		this.sliderItemTmpl;
		this.isMini = this.$el.hasClass(`${CLS}--mini`);
		this.isModal = this.$el.hasClass(`${CLS}--modal`);
		this.isCartDropdown = this.$el.hasClass(`${CLS}--cartDropdown`);
		this.isKlevu = !window.enableOptiRecommenations;
	}

	init() {
		console.log("Kesini: ", this.getProductsUrl);
		// prevent call initialization twice
		if (this.$el.hasClass(CLS_HAS_INITED)) {
			return;
		}

		this.setContentTemplate();
		this.setSliderTemplate();

		let contentModel = {
			title: this.$el.data('title') || '',
			content: this.$el.data('content') || '',
			alignCenter: this.$el.data('alignCenterHeader'),
			viewMoreLink: this.$el.data('viewMoreLink') || '',
		};
		this.renderContent(contentModel);
		this.getProducts();
	}

	renderContent(conteModel) {
		this.$el.html(this.contentTmpl(conteModel));
		this.$slider = this.$el.find(`.${CLS}-slider`);
		this.$sliderWrap = this.$el.find(`.${CLS}-sliderWrap`);
		this.$errorMessages = this.$el.find('.error-messages');
	}

	getProducts() {
		if (!this.getProductsUrl || !this.products) return;

		let handleError = (errorMsg) => {
			this.$el.addClass(CLS_HIDE);
			this.$errorMessages.html(errorMsg).addClass(CLS_ACTIVE);
			this.$el.removeClass(CLS_LOADING);
			this.renderItem([]);
		};

		this.$el.addClass(CLS_LOADING);
		this.$el.removeClass(CLS_ACTIVE);
		this.getProductRecommendations().then((items) => {
			if (items) {
				this.renderItem(items);
				if (this.isMini) {
					let badges = this.$el.find('.productItem-label');
					if (badges.length) {
						this.$el.addClass('has-badges');
					}
				}
			} else {
				this.renderItem([]);
			}
		}).catch((error) => {
			handleError(error);
		});
	}

	getProductRecommendations() {
		if (this.isKlevu) {
			return klevuService.searchByFilters([
				{
					key: 'productCode',
					settings: {
						singleSelect: false,
					},
					values: this.products.split(','),
				},
			], klevuService.convertData);
		} else {
			return this.getProductRecommendationsFromOpti();
		}
	}

	getProductRecommendationsFromOpti() {
		return new Promise((resolve, reject) => {
			Api.getApi(`${this.getProductsUrl}/${this.products}`).then((response) => {
				if (typeof response === 'string') {
					let data = JSON.parse(response);
					if (data.result == 'SUCCESS') {
						let items = data.response && data.response.items;
						resolve(items);
					} else {
						let errorMsg = data.message || data.error || '';
						reject(errorMsg);
					}
				} else {
					let errorMsg = response.message || response.error || '';
					reject(errorMsg);
				}
			}).catch((error) => {
				reject(error);
			});
		});
	}

	checkAvailableSale(saleAvailability) {
		return ![SALE_AVAILABILITY_INSTORE_NO_PRICE_VALUE, SALE_AVAILABILITY_INSTORE_VALUE].includes(saleAvailability);
	}

	renderItem(items) {
		let itemHtml = '';
		const limitProductToShowRecommendBlock = 5;
		const itemAvailableSales = items.filter((item) => !item.saleAvailability || this.checkAvailableSale(item.saleAvailability));
		const isShowRecommendBlock = itemAvailableSales.length >= limitProductToShowRecommendBlock;
		if (isShowRecommendBlock) {
			// prepare model
			for (let i = 0; i < itemAvailableSales.length; i++) {
				let itemModel = itemAvailableSales[i];
				let hasDiscount = itemModel.isDiscountPrice;
				itemModel.hasVariant = (itemModel.colors && itemModel.colors.items.length > 1) || (itemModel.sizes && itemModel.sizes.items.length > 1);
				itemModel.imageUrl = (itemModel.images && itemModel.images.length > 0 && itemModel.images[0].thumb);
				itemModel.price = itemModel.displayPrice;
				itemModel.isMini = this.isMini;
				itemModel.itemCode = (itemModel.variants && itemModel.variants.length > 0 && itemModel.variants[0].code);
				itemModel.productType = itemModel.type;
				itemModel.showCLROverlay = itemModel.isClearancePrice;
				itemModel.showKNOverlay = itemModel.isKnockDownPrice;
				itemModel.showPercentOverlay = hasDiscount;
				itemModel.showHPOverlay = itemModel.isHotPrice;
				itemModel.isKlevu = this.isKlevu;

				if (itemModel.showKNOverlay && itemModel.discountCode) {
					itemModel.discountCode = `${itemModel.discountCode}`;
				}

				if (hasDiscount) {
					let saleCode = '';
					if (itemModel.variants && itemModel.variants.length > 0) {
						saleCode = itemModel.variants[0].price.saleCode;
						itemModel.discountCode = utils.getDiscountText(saleCode);
					}
				}

				let recommendationId = this.getRecommendationId(itemModel.code);
				if (recommendationId) {
					itemModel.url = `${itemModel.url}?recommendationId=${recommendationId}`;
					itemModel.recommendationId = recommendationId;
				}

				if (itemModel.newInText) {
					itemModel.customLabel = {
						text: itemModel.newInText,
						color: itemModel.newInTextColor,
						bgColor: itemModel.newInTextBackgroundColor,
					};
				}
				if (!this.isKlevu) {
					let colours = itemModel.colors.items;
					if (colours && colours.length) {
						colours.forEach((item, index) => {
							if (item.hexColour) {
								let splitColourSwatch = item.hexColour.split(',');
								colours[index].arrColourSwatch = splitColourSwatch;
								colours[index].firstColor = splitColourSwatch[0];
								colours[index].secondColor = splitColourSwatch[1];
								colours[index].thirdColor = splitColourSwatch[2];
							}
						});
					}
				}

				let sliderItem = this.sliderItemTmpl(itemModel);
				// Limit badges <= 2
				let sliderItemHtml = $.parseHTML(sliderItem);
				if (!this.isKlevu) {
					let badges = $(sliderItemHtml).find('.productItem-labelWrap .productItem-label');
					badges = badges.splice(0, 2);
					$(sliderItemHtml).find('.productItem-labelWrap').html(badges);
				}

				let sliderItemFiltered = sliderItemHtml[1].outerHTML;
				itemHtml += sliderItemFiltered;
			}
			this.$slider.html(itemHtml);
			this.handleAddBtn();
			this.checkImageLoad();
		} else {
			this.removeRecommendedBlock();
			this.updateRecommendedProductsTab();
		}
	}

	removeRecommendedBlock() {
		this.$slider.closest('.pdp-info-item, .wrap-recommendations-hide-not-items, .productrecsblock').remove();
	}

	updateRecommendedProductsTab() {
		const hasRecommendedProducts = $("#recommendedProductsTab").children().length;
		if (!hasRecommendedProducts) {
			$('.recommendedProductsTab').remove();
		}
	}

	getRecommendationId(refCode) {
		if (!this.recs) return;
		let curRecs = this.recs.find(o => o.refCode === refCode);
		return curRecs && curRecs.id;
	}

	checkImageLoad() {
		let totalImages = this.$slider.find('img').length;

		const checkTotalImage = (imgCount) => {
			if (totalImages === imgCount) {
				this.initSwiper();
			}
		};

		let imgCount = 0;
		this.$slider.find('img').each((i, el) => {
			let $target = $(el);
			let img = new Image();
			img.onload = function() {
				imgCount += 1;
				checkTotalImage(imgCount);
			}

			img.onerror = function() {
				imgCount += 1;
				checkTotalImage(imgCount);
			}

			img.src = $target.attr('src');
		});
	}

	initSwiper() {
		// from mobile to desktop
		let slideToShow = 1.5;
		let slideToShowSm = 2;
		let slideToShowMd = 3;
		let slideToShowLg = 4;

		if (this.isMini) {
			slideToShow = slideToShowLg = slideToShowMd = slideToShowSm = 1;
		} else if (this.isModal) {
			slideToShow = slideToShowLg = slideToShowMd = slideToShowSm = 2;
		} else if (this.isCartDropdown) {
			slideToShow = slideToShowLg = slideToShowMd = slideToShowSm = 2.35;
		}

		const swiper = new Swiper(this.$sliderWrap[0], {
			init: false,
			slidesPerView: slideToShow,
			spaceBetween: this.isCartDropdown ? 20 : 16,
			freeMode: !this.isMini,
			mousewheel: true,
			navigation: {
				nextEl: this.$el.find('.swiper-button-next')[0],
				prevEl: this.$el.find('.swiper-button-prev')[0],
			},
			scrollbar: this.isMini ? false : {
				el: this.$sliderWrap.find('.swiper-scrollbar')[0],
				draggable: true,
			},
			pagination: !this.isMini ? false : {
				el: this.$el.find('.swiper-pagination')[0],
				clickable: true,
			},
			breakpoints: {
				[utils.BREAKPOINT.SM]: {
					slidesPerView: slideToShowSm,
				},
				[utils.BREAKPOINT.MD]: {
					slidesPerView: slideToShowMd,
				},
				[utils.BREAKPOINT.LG]: {
					slidesPerView: slideToShowLg,
				},
			},
		});

		swiper.on('init', () => {
			this.handleItemClick();
			if (!this.isKlevu) {
				this.handleOptionClick();
			}
			this.$el.removeClass(CLS_LOADING);
			this.$el.addClass(CLS_HAS_INITED);
			this.$el.removeClass(CLS_HIDE);
		});

		swiper.init();
	}

	handleAddBtn() {
			this.$el.find(`${BLK}btn`).on('click', (e) => {
				let $btn = $(e.target);
				let $item = $btn.closest(`${BLK}item`);
				e.preventDefault();

				// if mini redirect to PDP if has-variant
				if (this.isMini) {
					let url = $item.find(`.${CLS}-itemInner`).data('url');
					if (url) {
						window.location.href = url;
					}
					return;
				}

				if (this.isKlevu) {
					const itemId = $item.attr('data-ref-code');
					const productImage = $item.attr('data-image');

					$('[data-blk="ProductQuickView"]').trigger(EVENT_PRODUCT_QUICKVEW_SHOW, [{itemId, productImage}]);
				} else {
					if (!this.checkSelectedVariant($item)) return;
					this.$el.addClass(CLS_LOADING);
					let prop = this.prepareProductProp($item);
					addToCart(prop, () => {
						// success callback
						this.$el.removeClass(CLS_LOADING);
					}, () => {
						// fail callback
						this.$el.removeClass(CLS_LOADING);
					});
				}
			});
	}

	handleItemClick() {
		this.$el.find(`${BLK}itemInner`).each((i, item) => {
			$(item).on('click', (e) => {
				let $target = $(e.target);
				// redirect on click except on button or variant click
				if (!$target.hasClass(`${CLS}-btn`) && $target.closest(`.${CLS}-itemDetail`).length === 0) {
					window.location.href = item.getAttribute('data-url');
				}
			});
		});
	}

	prepareProductProp($item) {
		return {
			endpoint: $('.endpoints-definition').data('add-to-bag-endpoint') || '',
			code: $item.data(D_VAR_CODE) || $item.data(D_ITEM_CODE) || '',
			quantity: '1',
			size: '',
			datalayerDataSource: '',
			title: $item.find(`.${CLS}-itemTitle`).text() || '',
			cartLink: $('[data-cart-link]').data('cart-link') || '',
			prodImg: $item.find(`.${CLS}-itemImg`).attr('src') || '',
			recommendationId: $item.data(D_REC_ID) || '',
		};
	}

	handleOptionClick() {
		this.$el.find('.productListingBlock-option').on('click', (e) => {
			e.preventDefault();
			let $option = $(e.target);
			let $item = $option.closest(`.${CLS}-item`);
			if (!$option.hasClass('productListingBlock-option')) {
				$option = $option.closest('.productListingBlock-option');
			}
			this.setActiveOption($item, $option);
		});
	}

	setActiveOption($item, $option) {
		let currentVariant = {
			size: '',
			color: '',
		};

		currentVariant.size = $item.find(`.${BLK_PROD_LIST}-option.item-size.is-active.is-active-variant:visible`).data(D_ITEM_DESC) || '';
		if ($option.parent().hasClass(PRODUCT_CLASS.COLOR)) {
			currentVariant.color = $option.data(D_VAR_CODE);
			// when change the color, if the selected size existed then make the size 'active'
			let $sizeOptions = $item.find(`[data-parent-itemid="${currentVariant.color}"]`).find('.productListingBlock-options').children();
			for (let i = 0; i < $sizeOptions.length; i++) {
				if ($($sizeOptions[i]).data(D_ITEM_DESC) === currentVariant.size) {
					// keep existing the size selection
					$($sizeOptions[i]).addClass(CLS_ACTIVE);
					$($sizeOptions[i]).addClass(CLS_ACTIVE_VARIANT);
				} else {
					// remove active selection
					$($sizeOptions[i]).removeClass(CLS_ACTIVE);
					$($sizeOptions[i]).removeClass(CLS_ACTIVE_VARIANT);
				}
			}
		} else {
			currentVariant.size = $option.data(D_ITEM_DESC);
		}

		// check if this option has sizes then show the size with the same product id
		let variantCode;
		let desc = $option.data(D_ITEM_DESC);
		let prodType = $item.data(D_PROD_TYPE);

		if ($option.hasClass('has-sizes')) {
			let itemCode = $option.data(D_VAR_CODE);
			$item.find('[data-parent-itemid]').addClass(CLS_HIDE);
			$item.find('[data-parent-itemid="' + itemCode + '"]').removeClass(CLS_HIDE);
			variantCode= $item.find(`.${BLK_PROD_LIST}-optionsWrapper:not(.${CLS_HIDE}) .sizes .${CLS_ACTIVE_VARIANT}`).data(D_SKU);
			let sizeTextActive = $item.find(`.${BLK_PROD_LIST}-optionsWrapper:not(.${CLS_HIDE}) .sizes .${CLS_ACTIVE_VARIANT}`).text();
			$item.find('[data-parent-itemid="' + itemCode + '"]').find(`.${BLK_PROD_LIST}-optionText`).text(sizeTextActive);
		}

		$option.closest(`.${BLK_PROD_LIST}-optionsWrapper`).find(`.${BLK_PROD_LIST}-optionText`).text(desc);
		$option.closest(`.${BLK_PROD_LIST}-optionsWrapper`).find(`.${BLK_PROD_LIST}-option:not(.slide)`).removeClass(CLS_ACTIVE);

		$option.closest(`.${BLK_PROD_LIST}-optionsWrapper`).find(`.${BLK_PROD_LIST}-option`).removeClass(CLS_ACTIVE_VARIANT);
		$option.addClass(CLS_ACTIVE_VARIANT);

		// cleanup styles
		$option.not('.slide').addClass(CLS_ACTIVE);

		if (prodType !== PRODUCT_TYPE.COLOR_SIZE) {
			variantCode = this.getVariantCode($item);
		} else {
			variantCode = $option.data(D_SKU);
		}

		if (!variantCode && $option.hasClass(PRODUCT_CLASS.GENERIC)) {
			variantCode = $option.data(D_VAR_CODE);
		}

		if (variantCode) {
			$item.data(D_VAR_CODE, variantCode);
		}
	}

	getVariantCode($item) {
		let prodType = $item.data(D_PROD_TYPE);
		let itemCode = $item.data(D_ITEM_CODE);
		let colorSku = $item.find(`.${BLK_PROD_LIST}-options.colors .${CLS_ACTIVE_VARIANT}`).data(D_SKU) || null;
		let sizeSku = $item.find(`.${BLK_PROD_LIST}-options.sizes .${CLS_ACTIVE_VARIANT}`).data(D_SKU) || null;

		if (prodType === PRODUCT_TYPE.COLOR_SIZE) {
			sizeSku = $item.find(`.${BLK_PROD_LIST}-optionsWrapper:not(.${CLS_HIDE}) .sizes .${CLS_ACTIVE_VARIANT}`).data(D_SKU) || null;
		}

		let variantCode;
		switch (prodType) {
			case PRODUCT_TYPE.SIZE:
				variantCode = sizeSku;
				break;
			case PRODUCT_TYPE.COLOR:
				variantCode = colorSku;
				break;
			case PRODUCT_TYPE.COLOR_SIZE:
				variantCode = sizeSku;
				break;
			case PRODUCT_TYPE.GENERIC:
				variantCode = itemCode;
				break;
		}
		return variantCode;
	}

	checkSelectedVariant($item) {
		let errorMsg = `Please select product options before adding this product to your cart`;
		$item.find('.error-messages.add-to-cart-errors').text('').removeClass(CLS_ACTIVE);

		// if no variant code selected
		// if no options exist, don't check the add to cart
		let optionsCount = $item.find(`.${BLK_PROD_LIST}-option:visible`).length;
		// if no options has been selected
		if (optionsCount > 0) {
			// color only
			let colorOption = $item.find(`.${BLK_PROD_LIST}-options.colors .${BLK_PROD_LIST}-option.is-active.is-active-variant:not(.has-sizes)`);
			// color and size
			let colorSizeOption = $item.find(`.${BLK_PROD_LIST}-option.has-sizes.is-active.is-active-variant`);
			// size only
			let sizeOption = $item.find(`.${BLK_PROD_LIST}-option.item-size.is-active.is-active-variant`);
			// generic
			let genericOptions = $item.find(`.${BLK_PROD_LIST}-option.generic.is-active.is-active-variant`);

			// no variant has been selected
			if (
				colorOption.length == 0 &&
				colorSizeOption.length == 0 &&
				sizeOption.length == 0 &&
				genericOptions.length == 0
			) {
				$item.find('.error-messages.add-to-cart-errors').addClass(CLS_ACTIVE).text(errorMsg);
				$('.loading-spinner').removeClass(CLS_ACTIVE);
				return false;
			} else {
				if (colorSizeOption.length != 0) {
					let parentId = colorSizeOption.data(D_VAR_CODE);
					let sizeOption = $item.find('[data-parent-itemid="'+parentId+'"]').find(`.${BLK_PROD_LIST}-option.item-size.is-active.is-active-variant`);
					if (sizeOption.length == 0) {
						$item.find('.error-messages.add-to-cart-errors').addClass(CLS_ACTIVE).text(errorMsg);
						$('.loading-spinner').removeClass(CLS_ACTIVE);
						return false;
					} else {
						return true;
					}
				} else {
					return true;
				}
			}
		} else {
			return true;
		}
	}

	preventRedirect() {
		this.$el.find(`.${CLS}-itemDetail`).on('click', (e) => {
			e.preventDefault();
		});
	}

	setContentTemplate() {
		let itemFile = require('../../../blocks/recommendationsBlock/tmpl/recommendationsContent.hbs');
		Handlebars.registerPartial('recommendationsContent', itemFile);

		let itemTmpl = `
			{{> recommendationsContent
				blk="recommendationsBlock"
			}}
		`;

		let precompiled = new Function('return ' + Handlebars.precompile(itemTmpl))();
		this.contentTmpl = Handlebars.template(precompiled);
	}

	setSliderTemplate() {
		let itemFile = require('../../../blocks/recommendationsBlock/tmpl/recommendationsItem.hbs');
		let optionSizeFile = require('../../../blocks/recommendationsBlock/tmpl/optionSize.hbs');
		let optionColorFile = require('../../../blocks/recommendationsBlock/tmpl/optionColor.hbs');
		let itemLabel = require('../../../widgets/productItem/tmpl/_productItemLabel.hbs');
		// _productItemPrice
		Handlebars.registerPartial('recommendationsItem', itemFile);
		Handlebars.registerPartial('optionSize', optionSizeFile);
		Handlebars.registerPartial('optionColor', optionColorFile);
		Handlebars.registerPartial('_productItemLabel', itemLabel);

		let itemTmpl = `
			{{> recommendationsItem
				blk="recommendationsBlock"
			}}
		`;

		let precompiled = new Function('return ' + Handlebars.precompile(itemTmpl))();
		this.sliderItemTmpl = Handlebars.template(precompiled);
	}
}



// WEBPACK FOOTER //
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_04/_work/408/s/FrontEnd/src/views/blocks/recommendationsBlock/js/recommendationsBlock.js